<!-- Single gate: UI loads only when all data is set in constructor (no API-driven *ngIf flips = no NG0100) -->
<div class="col-xl-12" *ngIf="!dialogReady" style="padding: 1rem; text-align: center;">{{'Loading...' | translate}}</div>
<div class="col-xl-12" *ngIf="dialogReady">
	<div mat-dialog-content *ngIf="hasConfirmData && !isAnonymous">
		<div *ngIf="hasFieldsDetails">
			<div class="mb-20 profile-page-header-main" fxLayout="row" fxLayout.lt-md="column">
				<div fxFlex class="row1">
					<figure class="card-profile-image">
						<img style="max-height: 150px;" [src]="pictureLink"
							class="circle z-depth-2 responsive-img activator">
						<mat-icon *ngIf="isProfile" (click)="editProfileImage()" class="edit"
							title="{{ 'Edit' | translate }}">edit
						</mat-icon>
					</figure>
					<div class="name">{{confirmData['title']}} {{confirmData['firstName']}}
						{{confirmData['lastName']}}
					</div>
					<div class="email">
						<span class="inlineText">{{confirmData['email']}}</span>
					</div>
					<div class="email" *ngIf="hasFieldsDetails && hasOrganization">
						<span class="inlineText">
							<ng-container *ngFor="let res of confirmDataResources">
								<div class="inlineText" *ngIf="organization && organization._id === res.organizationId ">{{res['name']}}</div>
							</ng-container>
						</span>
					</div>
					<div class="email" *ngIf="confirmData && confirmData['phone'] && confirmData['phone'] !== ''">
						<span class="inlineText">{{(fieldsDetails && fieldsDetails['phone'] ? fieldsDetails['phone']['displayName'] : '') | translate}} : {{confirmData['phone']}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="isAnonymous" mat-dialog-content class="anonymous-dialog">
		<div class="anonymous-dialog-msg">
			This account belongs to an anonymous user. There are no profile details associated with it.
		</div>
	</div>
	<div mat-dialog-actions>
		<div class="mb-20 btnList" fxLayout="row" fxLayout.lt-md="column" fxFlex
			*ngIf="hasModalSetting && !hasFooter">
			<div fxFlex style="align-items: center; display: flex;">
				<button mat-raised-button color="danger" (click)="closeModal(undefined)">{{'Close' |
					translate}}</button>
				<button *ngIf="isProfile" mat-raised-button (click)="editProfile()">
					{{'Edit Profile' | translate}}
				</button>
				<button *ngIf="isProfile" mat-raised-button (click)="changePassword()">
					{{'Change Password' | translate}}
				</button>
			</div>
		</div>
	</div>
</div>